import React, { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";

// import JS files
import MuiModal from "../../../mui/MuiModal";
import MuiTextFieldHook from "../../../mui/MuiTextFieldHook";
import MuiButton from "../../../mui/MuiButton";
import MuiSelectHook from "../../../mui/MuiSelectHook";
import MuiUpload from "../../../mui/MuiUpload";
import MuiCheckBoxGroup from "../../../mui/MuiCheckBoxGroup";
import useFetch from "../../../../context/useFetch";
import { Province } from "../../../../Province";

// import others files

const AddProvince = (props) => {
  const {
    register,
    reset,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      // name: props.editItemData !== undefined ? props.editItemData?.name : "",
      password: "",
      username: "",
      name:  props.editItemData !== undefined ? props.editItemData?.name : "",
      province:
        props.editItemData !== undefined ? props.editItemData?.province : "",
    },
  });

  const [apiPostData, setApiPostData] = useState([]);

  const editData = useFetch({
    url: `User_Service/${props.editItemData?.username}`,
    method: "PATCH",
    trigger: false,
    data: apiPostData,
    argFunc: (res) => {
      reset({ province: "", username: "", password: "", name: "" });
      // setTagInputList([]);
      props.setEditItemData(undefined);
      props.apiCall.reFetch();
      props.setOpenModal(false);
    },
  });

  const createData = useFetch({
    url: `User_Service`,
    method: "POST",
    trigger: false,
    data: apiPostData,
    argFunc: (res) => {
      reset({ province: "", username: "", password: "", name: "" });
      props.apiCall.reFetch();
      props.setOpenModal(false);
    },
    errMessage: (mess) => {
      if ("password1" in mess) {
        if (
          mess.response.data.password1.includes(
            "This password is too short. It must contain at least 8 characters."
          ) ||
          mess.response.data.password1.includes(
            "This password is too common."
          ) ||
          mess.response.data.password1.includes(
            "This password is entirely numeric."
          )
        ) {
          // showMessage = "pass";
          // setError("password1", {
          //   type: "manual",
          //   message: "رمز عبور نامعتبر است",
          // });
          toast.error("رمز عبور نامعتبر است", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
      if ("username" in mess) {
        if (
          mess.response.data.username.includes(
            "A user with that username already exists."
          )
        ) {
          toast.error("نام کاربری، قبلا انتخاب شده است", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        if (
          mess.response.data.username.includes(
            "Enter a valid username. This value may contain only letters, numbers, and @/./+/-/_ characters."
          )
        ) {
          toast.error("نام کاربری، نمی‌تواند دارای فاصله باشد.", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    },
  });

  const onSubmit = (data) => {
    let postData = new FormData();

    if (props.editItemData !== undefined) {
      postData.append("province", data["province"]);
      postData.append("name", data["name"]);

      postData.append(
        "province_fa",
        Province.filter((it) => it.value == data["province"])[0].name
      );

      setApiPostData(postData);
      editData.reFetch();
    } else {
      postData.append("username", data["username"]);
      postData.append("job", "TreatmentProvinceExpert");
      postData.append("name", data["name"]);
      postData.append("province", data["province"]);
      postData.append(
        "province_fa",
        Province.filter((it) => it.value == data["province"])[0].name
      );
      postData.append("password1", data["password"]);
      postData.append("password2", data["password"]);

      setApiPostData(postData);
      createData.reFetch();
    }
  };

  useEffect(() => {
    if (props.editItemData !== undefined) {
      // setAreaOptions(props.editItemData.area);
      // setArea(props.editItemData.area);
      // setRoleName(props.editItemData.name);
    }
  }, [props]);
  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="md:w-2/5"
        isOverflow={true}
      >
        <div>
          <div className="mt-4 text-center">
            {props.editItemData == undefined ? "ایجاد دسترسی استان" : "ویرایش دسترسی استان"}
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-8">
              <MuiSelectHook
                size="small"
                inputLabel="استان"
                label="province"
                control={control}
                name="province"
                register={{
                  required: {
                    value: true,
                    message: "استان را انتخاب کنید",
                  },
                }}
                labelId="province-label"
                id="province-select"
                menuItems={Province.map((it) => {
                  return { name: it.name, value: it.value };
                })}
                keyOnLoop="name"
              />
            </div>
            <div className="mt-8">
              <MuiTextFieldHook
                id="outlined-basic"
                label="نام و نام خانوادگی مسئول"
                variant="outlined"
                size="small"
                name="name"
                control={control}
                register={{
                  required: {
                    value: true,
                    message: "نام و نام خانوادگی مسئول را وارد کنید",
                  },
                }}
              />
            </div>
            {props.editItemData == undefined && (
              <div className="mt-8">
                <MuiTextFieldHook
                  id="outlined-basic"
                  label="نام کاربری"
                  variant="outlined"
                  size="small"
                  name="username"
                  control={control}
                  register={{
                    required: {
                      value: true,
                      message: "نام کاربری را وارد کنید",
                    },
                  }}
                  isLTR
                />
              </div>
            )}
            {props.editItemData == undefined && (
              <div className="mt-8">
                <MuiTextFieldHook
                  id="outlined-basic"
                  label="رمز عبور"
                  variant="outlined"
                  size="small"
                  name="password"
                  control={control}
                  register={{
                    required: {
                      value: true,
                      message: "رمز عبور را وارد کنید",
                    },
                  }}
                  isLTR
                />
              </div>
            )}
            <div className="mt-8">
              <MuiButton
                // onClick={() => props.onClick()}
                variant="contained"
                // icon={<AddCircleOutlineIcon />}
                // disabled={
                //   props.editItemData !== undefined
                //     ? false
                //     : productPic instanceof File && areaOptions.length > 0
                //     ? false
                //     : true
                // }
                color="primary"
                text={props.editItemData !== undefined ? "ویرایش" : "ایجاد"}
                isFullWidth
                withoutOnClick
                type={"submit"}
              />
            </div>
          </form>
        </div>
      </MuiModal>
    </>
  );
};

export default AddProvince;
